import cn from 'classnames';
import React, { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Input } from '@infologistics/frontend-libraries';

import { IBaseUrlFormProps as IProps } from './types';

import styles from '../AuthNew.module.scss';

const BaseUrlForm: FC<IProps> = (props) => {
  const { handleChange, handleSubmit, values, resetForm, resetText } = props;
  const { t } = useTranslation();
  const { baseUrl, isBoldText } = values;

  const refButtons = useRef<HTMLDivElement>(null);

  const classText = isBoldText ? 'fw-700' : '';

  return (
    <form onSubmit={handleSubmit} noValidate className={cn(styles.formUrl, `mb-2 d-flex`)}>
      <Input
        name='baseUrl'
        onChange={(e) => {
          const { value } = e.target;

          handleChange(e);

          if (isBoldText) {
            resetText(value);
          }
        }}
        value={baseUrl}
        inputSize='md'
        classes={{ wrapper: cn(styles.base_url, classText), input: 'py-2' }}
        style={{
          height: refButtons.current?.clientHeight + 'px',
        }}
      />
      <div className={cn(styles.formUrl__buttons, 'd-flex')} ref={refButtons}>
        <Button type='submit' theme='primary' size='large' classes='px-5 py-2'>
          <span className='fw-700'>{t('auth:setPath')}</span>
        </Button>
        <Button type='button' theme='default' size='large' onClick={resetForm} classes='px-5 py-2'>
          <span className='fw-700'>{t('auth:reset')}</span>
        </Button>
      </div>
    </form>
  );
};

export default BaseUrlForm;
